import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/ibm-cloudnative-journey/ibm-cloudnative-journey/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Tabs = makeShortcode("Tabs");
const Tab = makeShortcode("Tab");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Services</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Ingress</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Activities</AnchorLink>
    </AnchorLinks>
    <h1>{`Services`}</h1>
    <p>{`An abstract way to expose an application running on a set of Pods as a network service.`}</p>
    <p>{`Kubernetes Pods are mortal. They are born and when they die, they are not resurrected. If you use a Deployment to run your app, it can create and destroy Pods dynamically.`}</p>
    <p>{`Each Pod gets its own IP address, however in a Deployment, the set of Pods running in one moment in time could be different from the set of Pods running that application a moment later.`}</p>
    <p>{`In Kubernetes, a Service is an abstraction which defines a logical set of Pods and a policy by which to access them (sometimes this pattern is called a micro-service). The set of Pods targeted by a Service is usually determined by a selector (see below for why you might want a Service without a selector).`}</p>
    <p>{`If you’re able to use Kubernetes APIs for service discovery in your application, you can query the API server for Endpoints, that get updated whenever the set of Pods in a Service changes.`}</p>
    <p>{`For non-native applications, Kubernetes offers ways to place a network port or load balancer in between your application and the backend Pods.`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`IKS & OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/services-networking/service/"
        }}>{`Services`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tutorials/kubernetes-basics/expose/expose-intro/"
        }}>{`Exposing Services`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: apps/v1
kind: Deployment
metadata:
  name: my-deployment
  labels:
    app: nginx
    version: v1
spec:
  replicas: 3
  selector:
    matchLabels:
      app: nginx
  template:
    metadata:
      labels:
        app: nginx
        version: v1
    spec:
      containers:
      - name: nginx
        image: bitnami/nginx
        ports:
        - containerPort: 8080
          name: http
---
apiVersion: v1
kind: Service
metadata:
  name: my-service
spec:
  selector:
    app: nginx
  ports:
    - name: http
      port: 80
      targetPort: http
`}</code></pre>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{` Get Service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get svc
`}</code></pre>
        <p><strong parentName="p">{` Get Service Description `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc describe svc my-service
`}</code></pre>
        <p><strong parentName="p">{` Expose a service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc expose service <service_name>
`}</code></pre>
        <p><strong parentName="p">{` Get Route for the Service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get route
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <p><strong parentName="p">{` Get Service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl get svc
`}</code></pre>
        <p><strong parentName="p">{` Get Service Description `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl describe svc my-service
`}</code></pre>
        <p><strong parentName="p">{` Get Service Endpoints `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl get ep my-service
`}</code></pre>
        <p><strong parentName="p">{` Expose a Deployment via a Service `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`kubectl expose deployment my-deployment --port 80 --target-port=http --selector app=nginx --name my-service-2 --type NodePort
`}</code></pre>
      </Tab>
    </Tabs>
    <h1>{`Routes`}</h1>
    <p>{`(OpenShift Only)`}</p>
    <p>{`Routes are Openshift objects that expose services for external clients to reach them by name.  `}</p>
    <p>{`Routes can insecured or secured on creation using certificates.`}</p>
    <p>{`The new route inherits the name from the service unless you specify one using the —name option.`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/online/pro/dev_guide/routes.html"
        }}>{`Routes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/networking/routes/route-configuration.html"
        }}>{`Route Configuration`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/networking/routes/secured-routes.html"
        }}>{`Secured Routes`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <p><strong parentName="p">{` Route Creation `}</strong></p>
    <pre><code parentName="pre" {...{}}>{`apiVersion: v1
kind: Route
metadata:
  name: frontend
spec:
  to:
    kind: Service
    name: frontend
`}</code></pre>
    <p><strong parentName="p">{` Secured Route Creation `}</strong></p>
    <pre><code parentName="pre" {...{}}>{`apiVersion: v1
kind: Route
metadata:
  name: frontend
spec:
  to:
    kind: Service
    name: frontend
  tls:
    termination: edge
`}</code></pre>
    <h3>{`Commands`}</h3>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{` Create Route from YAML `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc apply -f route.yaml
`}</code></pre>
        <p><strong parentName="p">{` Get Route `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get route
`}</code></pre>
        <p><strong parentName="p">{` Describe Route `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get route <route-name>
`}</code></pre>
        <p><strong parentName="p">{` Get Route YAML `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc get route <route-name> -o yaml
`}</code></pre>
      </Tab>
    </Tabs>
    <h1>{`Ingress`}</h1>
    <p>{`An API object that manages external access to the services in a cluster, typically HTTP.`}</p>
    <p>{`Ingress can provide load balancing, SSL termination and name-based virtual hosting.`}</p>
    <p>{`Ingress exposes HTTP and HTTPS routes from outside the cluster to services within the cluster. Traffic routing is controlled by rules defined on the Ingress resource.`}</p>
    <h2>{`Resources`}</h2>
    <p><strong parentName="p">{`OpenShift`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/networking/ingress-operator.html"
        }}>{`Ingress Operator`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://docs.openshift.com/container-platform/4.3/networking/configuring_ingress_cluster_traffic/configuring-ingress-cluster-traffic-ingress-controller.html"
        }}>{`Using Ingress Controllers`}</a></li>
    </ul>
    <p><strong parentName="p">{`IKS`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/services-networking/ingress/"
        }}>{`Ingress`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/concepts/services-networking/ingress-controllers/"
        }}>{`Ingress Controllers`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kubernetes.io/docs/tasks/access-application-cluster/ingress-minikube/"
        }}>{`Minikube Ingress`}</a></li>
    </ul>
    <h2>{`References`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`apiVersion: networking.k8s.io/v1beta1 # for versions before 1.14 use extensions/v1beta1
kind: Ingress
metadata:
  name: example-ingress
spec:
  rules:
  - host: hello-world.info
    http:
      paths:
      - path: /
        backend:
          serviceName: web
          servicePort: 8080
`}</code></pre>
    <Tabs mdxType="Tabs">
      <Tab label="OpenShift" mdxType="Tab">
        <p><strong parentName="p">{` View Ingress Status `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc describe clusteroperators/ingress
`}</code></pre>
        <p><strong parentName="p">{` Describe default Ingress Controller `}</strong></p>
        <pre><code parentName="pre" {...{}}>{`oc describe --namespace=openshift-ingress-operator ingresscontroller/default
`}</code></pre>
      </Tab>
      <Tab label="IKS" mdxType="Tab">
        <pre><code parentName="pre" {...{}}>{`minikube addons enable ingress
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get pods -n kube-system | grep ingress
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl run web --image=bitnami/nginx --port=8080
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl expose deployment web --target-port=8080 --type=NodePort
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get svc web
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`minikube service --url web
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`stern ingress -n kube-system
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubectl get ingress
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`kubcetl describe ingress example-ingress
`}</code></pre>
        <pre><code parentName="pre" {...{}}>{`curl hello-world.info --resolve hello-world.info:80:<ADDRESS>
`}</code></pre>
      </Tab>
    </Tabs>
    <h2>{`Activities`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Task`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Link`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><em parentName="strong">{` Try It Yourself `}</em></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Creating Services`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Create two services with certain requirements.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><a parentName="td" {...{
              "href": "../activities/labs/lab8"
            }}>{`Setting up Services`}</a></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      